import {useTranslation} from "react-i18next";
import FormFieldBox from "../../common/form/FormFieldBox";
import TextInput from "../../common/form/TextInput";
import FormRow from "../../common/form/FormRow";
import React, {useEffect} from "react";
import {Control, useWatch} from "react-hook-form";
import FormCheckbox from "../../common/form/FormCheckbox";
import {UseFormGetFieldState, UseFormSetValue} from "react-hook-form/dist/types/form";

type Props = {
    index: number
    control: Control<any>
    setValue: UseFormSetValue<any>
    getFieldState: UseFormGetFieldState<any>
}


export const HotDeskAssociationLimitForm = ({ index, control, setValue, getFieldState }: Props) => {
    const { t } = useTranslation()

    useEffect(() => {
        setValue(`fieldUpdates.${index + 1}.fieldName`, 'hotDeskAssociationLimitHours')
    }, [setValue, index]);

    const associationLimitEnabled = useWatch({
        control,
        name: `fieldUpdates.${index}.values.0.selected`,
    })

    const associationLimitHours = useWatch({
        control,
        name: `fieldUpdates.${index + 1}.values.0.stringValue`,
    })

    useEffect(() => {
        if (associationLimitEnabled && !associationLimitHours) {
            setValue(`fieldUpdates.${index + 1}.values.0.stringValue`, '12')
        }
    }, [associationLimitEnabled, associationLimitHours, setValue, index]);

    return (<FormRow>
        <FormFieldBox>
            <FormCheckbox
                label={t('users.edit.association-limit')}
                name={`fieldUpdates.${index}.values.0.selected`}
                control={control}
                setValue={setValue}
                getFieldState={getFieldState}
            />
        </FormFieldBox>
        {associationLimitEnabled &&
            <FormFieldBox>
                <TextInput
                    readonly={false}
                    label={t('users.edit.association-limit-hours')}
                    name={`fieldUpdates.${index + 1}.values.0.stringValue`}
                    control={control}
                />
            </FormFieldBox>
        }
    </FormRow>)
}
